import { ArrowLeft, Button, Modal, Separator } from '@chain-zen/ui'

interface ISetupWorkspaceLayout {
  children: React.ReactNode
  footer?: {
    label: string
    onClick: () => void
  }
  subtitle?: string
  title: string | React.ReactNode
}

/**
 * This component is used to layout the setup workspace process.
 */
export const SetupWorkspaceLayout = (props: ISetupWorkspaceLayout) => {
  const { title, subtitle, children, footer } = props

  return (
    <>
      <Modal.Header className="p-0">
        <div className="mb-2">
          {typeof title === 'string' ? <h2 className="font-semibold text-lg mb-1">{title}</h2> : title}
          {subtitle ? <h1 className="text-sm">{subtitle}</h1> : null}
        </div>
        <Separator />
      </Modal.Header>
      <Modal.Body className="p-0 mt-4">{children}</Modal.Body>
      {footer ? (
        <Modal.Footer className="p-0 mt-5">
          <div className="flex justify-start w-full">
            <Button onClick={footer?.onClick} className="h-7" variant="outline">
              <ArrowLeft className="w-4 h-4" /> {footer?.label}
            </Button>
          </div>
        </Modal.Footer>
      ) : null}
    </>
  )
}
